import _Bold from "./bold";
import _BoldGreen from "./boldGreen";

export const Bold = _Bold;
export const BoldGreen = _BoldGreen;